exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media (min-width: 768px){.fact-states{flex-direction:column;max-height:600px}}.fact-states .fact-state a{font-family:protipo,sans-serif !important;font-weight:300 !important;font-size:16px !important;color:#385369 !important}\n", ""]);

